import { render, staticRenderFns } from "./create-from-pr.vue?vue&type=template&id=70919fa0"
import script from "./create-from-pr.vue?vue&type=script&lang=js"
export * from "./create-from-pr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports